<div class="account-links">
  <div class="account-dropdown-toggle" (click)="toggleAccountDropdown()">
    <span class="circle">
      <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="person-fill">
        <g><path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path></g>
      </svg>
    </span>
    <div class="account-name">
      {{currentUser.firstName}} {{currentUser.secondName}}
    </div>
  </div>
  <ul class="account-dropdown" *ngIf="showDropdown">
    <li>
      <a routerLink="/account/settings">
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <g><path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path></g>
        </svg>
        {{locale.settingsLinkText}}
      </a>
    </li>
    <li>
      <a (click)="goToMyFJ()">
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
          <g><path fill-rule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"></path></g>
        </svg>
        {{locale.returnMyFJLinkText}}
      </a>
    </li>
    <li>
      <a routerLink="/help">
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
        </svg>
        {{locale.helpLinkText}}
      </a>
    </li>
    <li>
      <a (click)="signOut()">
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <g><path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"></path><path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"></path></g>
        </svg>
        {{locale.signoutLinkText}}
      </a>
    </li>
  </ul>
</div>



// WEBPACK FOOTER //
// ./src/app/components/_shared/main-account-links/main-account-links.component.html